import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gray-50">
      <div className="tw-text-center tw-p-8">
        <h1 className="tw-text-4xl tw-font-bold tw-text-gray-900 tw-mb-4">
          Oops! Page Not Found
        </h1>

        <p className="tw-text-gray-600 tw-mb-8 tw-text-lg">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <button
          onClick={() => navigate("/")}
          className="tw-flex tw-justify-center tw-text-center tw-mx-auto tw-items-center tw-gap-2 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
        >
          <svg
            className="tw-w-5 tw-h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
